"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var utils_1 = require("@near-js/utils");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return utils_1.Logger; } });
